const testimonialsContainer = document.querySelector('.testimonials')
const testimonialsSlider = document.querySelector('.testimonials .keen-slider')
const leftArrow = document.querySelector('.testimonials .arrow-left')
const rightArrow = document.querySelector('.testimonials .arrow-right')

if (testimonialsSlider && testimonialsContainer) {
	const TABLET_BREAKPOINT = 992
	const slides = testimonialsSlider.querySelectorAll('.keen-slider__slide')
	const totalSlides = slides.length

	// Create dots container for mobile
	const dotsContainer = document.createElement('div')
	dotsContainer.className = 'testimonials-dots'
	for (let i = 0; i < totalSlides; i++) {
		const dot = document.createElement('button')
		dot.className = `dot${i === 0 ? ' active' : ''}`
		dot.setAttribute('aria-label', `Go to slide ${i + 1}`)
		dotsContainer.appendChild(dot)
	}
	testimonialsContainer.appendChild(dotsContainer)
	const dots = dotsContainer.querySelectorAll('.dot')

	const updateDots = (index) => {
		dots.forEach((dot, i) => {
			dot.classList.toggle('active', i === index)
		})
	}

	const slider = new KeenSlider(testimonialsSlider, {
		slides: {
			perView: 1,
			spacing: 16,
		},
		breakpoints: {
			'(min-width: 512px)': {
				slides: { spacing: 16 },
			},
			'(min-width: 768px)': {
				slides: { perView: 1.5, spacing: 16 },
			},
			'(min-width: 1200px)': {
				slides: { perView: 2.8, spacing: 32 },
			},
			'(min-width: 1600px)': {
				slides: { perView: 3.3, spacing: 32 },
			},
		},
		slideChanged(s) {
			updateDots(s.track.details.rel)
		},
	})

	// Dot click handlers
	dots.forEach((dot, index) => {
		dot.addEventListener('click', () => {
			slider.moveToIdx(index)
		})
	})

	if (leftArrow) {
		leftArrow.addEventListener('click', () => {
			slider.prev()
		})
	}

	if (rightArrow) {
		rightArrow.addEventListener('click', () => {
			const { rel, maxIdx } = slider.track.details
			if (rel >= maxIdx) {
				slider.moveToIdx(0)
			} else {
				slider.next()
			}
		})
	}
}

